export const getVideoEmbedSrc = (url: string) => {
  const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
  const urlSanitized = url.replace(/(>|<)/gi, '');
  if (!youtubeRegex.test(urlSanitized)) {
    return url;
  }
  const id = urlSanitized.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)[2]?.split(/[^0-9a-z_\\-]/i)[0];
  return id ? `https://www.youtube-nocookie.com/embed/${id}` : url;
};
